<template>
    <div id="StepsThird">
        <a-spin :spinning="spinning">
            <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-form-model-item :label="textTit + '名称'">
                    <p class="model-item-value">{{courseInfo.name}}</p>
                </a-form-model-item>
                <a-form-model-item label="备注">
                    <p class="model-item-value">{{courseInfo.description || '无'}}</p>
                </a-form-model-item>
                <a-form-model-item label="适用学段">
                    <p class="model-item-value">{{resourcesItemValue && resourcesItemValue.period}}</p>
                </a-form-model-item>
                <a-form-model-item :label="textTit + '资源'">
                    <div style="width: 440px;">
                        <ResourcesItem :resource-data="resourcesItemValue" :key="new Date()" style="margin: 0;"/>
                    </div>
                </a-form-model-item>
                <a-form-model-item label="登录码类型">
                    <p class="model-item-value">
                        <span v-if="courseInfo.codeType === 1">班级码</span>
                        <span v-else-if="courseInfo.codeType === 3">学生码</span>
                        <span v-else>无登录码</span>
                    </p>
                </a-form-model-item>
                <a-form-model-item label="生效时间">
                    <p class="model-item-value" style="width: 350px;">{{courseInfo.effectiveDate}} ~ {{courseInfo.uneffectiveDate}}</p>
                </a-form-model-item>
            </a-form-model>
            <div style="text-align: center;margin-top: 20px;">
                <a-button @click="preserveAndOut" type="primary" ghost style="margin-right: 50px;">
                    上一步
                </a-button>
                <a-button :loading="submitButtonLoading" @click="preserveAndOut(1)" type="primary">
                    确认添加
                </a-button>
            </div>
        </a-spin>
    </div>
</template>

<script>
    import ResourcesItem from '@/pages/projectImpl/courseManage/components/ResourcesItem.vue'
    import { ArrayUnique2 } from '@/pages/projectImpl/js/utils'

    export default {
        name: 'StepsThird',
        components: { ResourcesItem },
        data() {
            return {
                spinning: true,
                submitButtonLoading: false,
                courseInfo: this.$store.getters["course/getEditCourse"](),
                resourcesItemValue: {
                    // course: {}
                },
                textTit:'测评'
            }
        },
        mounted(){
            this.textTit = this.$route.query.textTit;
            this.getResourcesInfo()
        },
        methods: {
            getResourcesInfo(){
                const params = {
                    id: this.courseInfo.id
                }
                this.$http.Course.getmodel(params).then(res => {
                    const {data} = res;
                    let Data = {
                        icon:data.courseResourceIcon,
                        courseName:data.courseResourceName,
                        childCourseCount:data.childCourseCount,
                        period:data.courseResourcePeriod,
                        configUserCount:data.courseResourceConfigUserCount,
                        isLimitUser:data.courseResourceIsLimitUser,
                        maxUserCount:data.courseResourceMaxUserCount,
                        description:data.data
                    }
                    this.resourcesItemValue = Data;
                    console.log(this.resourcesItemValue);
                }).finally(() => {
                  this.spinning = false
                })
            },
            preserveAndOut(val){
                if (val === 1){
                    const json = {
                        addOrganizationUserIds: ArrayUnique2(this.courseInfo.tree.addClassUserIds.filter(f => !!f).map(m => Number(m.split(",")[0]))),
                        deleteOrganizationUserIds: ArrayUnique2(this.courseInfo.tree.deleteClassUserIds.filter(f => !!f).map(m => Number(m.split(",")[0]))),
                        projectCourseConfigId: this.courseInfo.id,
                        projectCourseResourceId: this.courseInfo.projectCourseResourceId
                    }
                    this.submitButtonLoading = true
                    this.$http.Course.setOpeningCoursesAsync(json).then(res => {
                        const {message} = res;
                        this.$message.success(message);
                        this.$store.commit("course/setEditCourse", null);
                        setTimeout(() => {
                            document.querySelector(".tabs-head .ant-tabs-tab-active .icon-close").click();
                            this.$router.push("/projectImpl/organizationDetails");
                        }, 500)
                    }).finally(() => {
                      this.submitButtonLoading = false
                    })
                } else {
                    this.$emit('steps', 1)
                }
            }
        }
    }
</script>

<style scoped>
    #StepsThird {
        width: 500px;
        margin: 0 auto;
    }

    #StepsThird >>> .ant-form-item-label > label {
        color: #333;
        font-size: 16px;
        font-weight: bold;
    }
    .model-item-value{
        font-size: 16px;
        margin: 0;
    }
</style>
